import React from 'react';
import pcLogo from '../../../assets/Images/pc-logo.png';
import type { PortalHeaderProps } from '../../../shared/types/portal-base';

const PortalHeader: React.FC<PortalHeaderProps> = ({ className = '' }) => {
  const currentDate = new Date();
  const timeString = currentDate.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    hour12: true 
  });

  return (
    <header className={`portal-header ${className}`}>
      <div className="portal-header-left">
        <img 
          src={pcLogo} 
          alt="Pacific Cross Logo" 
          className="portal-logo"
        />
        <h1 className="portal-title">TRAVEL PAYMENT PORTAL</h1>
      </div>
      
      <div className="portal-header-right">
        <p className="portal-welcome">Welcome, Agent</p>
        <p className="portal-last-login">Last login: Today, {timeString}</p>
      </div>
    </header>
  );
};

export default PortalHeader;